import { slideToggle } from './js-helpers.js';

let flag = false;

const toggleAccordion = async (btn, target) => {
	if (flag || !target) return;
	flag = true;

	try {
		btn.classList.toggle('active');

		await slideToggle(target);
	} finally {
		flag = false;
	}
};

document.querySelectorAll('button[data-accordion]').forEach(btn => {
	const target = btn.dataset.accordion;

	btn.addEventListener('click', () => toggleAccordion(
		btn,
		target === 'next' ? btn.nextElementSibling : document.getElementById(target)
	));
});
